import { component } from 'picoapp'
import $ from 'quantdom';

export default component((node) => {
	
  const vidUrl = new URL($(node).attr('data-video-src-url'))
	const vidSrcType = $(node).attr('data-video-src-type')
	const vidAutoplay = $(node).attr('data-video-autoplay') == 'true' ? 1 : 0
  let vimeoPlayer
  let youtubePlayer

  if (vidSrcType == 'url' && vidUrl.toString().indexOf('youtube') != -1) {
    vidUrl.searchParams.forEach(function (val, key) {
      if (key == 'v') {
        setupYoutubePlayer(val)
      }
    })
  } else if (vidSrcType == 'url' && vidUrl.toString().indexOf('vimeo') != -1) {
    setupVimeo(vidUrl.toString().split('vimeo.com/')[1])
  }

  // Vimeo functions
  function setupVimeo(id) {
    setVimeoThumbnail(id)
    setVimeoEmbed(id)
    vimeoPlayer = createVimeoPlayer()
  }

  function createVimeoPlayer() {
    if (window.Vimeo !== undefined) {
      vimeoPlayer = new Vimeo.Player($(node).find('#video-module-vimeo-player'))
    } else {
      setTimeout(createVimeoPlayer, 100)
    }
  }

  async function setVimeoThumbnail(id) {
    const response = await fetch(`https://vimeo.com/api/v2/video/${id}.json`)
    const jsonData = await response.json()
    $(node).attr('data-video-id', id)
    $(node).attr('data-video-src-domain', 'vimeo')
    $(node).find('[data-thumbnail]').attr('src', jsonData[0].thumbnail_large)
  }

	function setVimeoEmbed(id) {
    $(node).find('[data-video-frame]').html(`<iframe 
      id="video-module-vimeo-player"
      style="flex-grow: 1;"
      src="https://player.vimeo.com/video/${id}?autoplay=${vidAutoplay}" 
      width="100%" 
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture" 
      allowfullscreen
      webkitallowfullscreen
      mozallowfullscreen 
    ></iframe>`)
  }

  // Youtube functions
  function setupYoutubePlayer(id) {
    $(node).attr('data-video-id', id)
    $(node).attr('data-video-src-domain', 'youtube')
    $(node).find('[data-thumbnail]').attr('src', `https://img.youtube.com/vi/${id}/maxresdefault.jpg`)
    setYoutubeEmbed(id)

    window.onYouTubeIframeAPIReady = function () {
      youtubePlayer = new YT.Player('video-module-yt-player')
    }
  }

  function setYoutubeEmbed(id) {
    $(node).find('[data-video-frame]').html(`<iframe
      id="video-module-yt-player"
      style="flex-grow: 1; height: 100%; width: 100%;"
      width="560"
      height="315"
      src="https://www.youtube.com/embed/${id}?autoplay=${vidAutoplay}&enablejsapi=1"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>`)
  }

  $(node)
    .find('[data-play-button]')
    .on('click', function () {
      const domain = $(node).attr('data-video-src-domain')
      $(node).find('[data-thumbnail]').remove()
      $(node).find('[data-play-button]').remove()

      if (vidSrcType == 'file') {
        $(node).find('video')[0].play()
      } else if (domain == 'youtube') {
        youtubePlayer.playVideo()
      } else if (domain == 'vimeo') {
        vimeoPlayer.play()
      }
    })
})
